function getDateFromNowAddWeeks(weeks) {
  const date = new Date();
  const newMonth = date.getMonth() + parseInt(weeks);
  date.setMonth(newMonth);
  return date;
}
function getStartAndEndDate(dates) {
  let daysToSort = [...dates];
  daysToSort = daysToSort.map((el) => {
    if (el.date) {
      return el.date;
    } else return el;
  });
  const sortedDates = daysToSort.sort((a, b) => a.getTime() - b.getTime());
  return [
    {
      start: addHoursToDate(sortedDates[0], 5),
      end: addHoursToDate(sortedDates[sortedDates.length - 1], 5),
    },
  ];
}
function isDateBetweenDates(date, dateRangeFirst, dateRangeLast) {
  const dateInMilliseconds = date.getTime();

  const dateRangeFirstInMilliseconds = dateRangeFirst.getTime();

  const dateRangeLastInMilliseconds = dateRangeLast.getTime();

  return dateInMilliseconds >= dateRangeFirstInMilliseconds && dateInMilliseconds <= dateRangeLastInMilliseconds;
}

function addHoursToDate(date, hours) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() + hours);
}

function getUTCDateRange(startAndEndDate, isForCalendarEvents = false, noWeekends = false, holidays = []) {
  startAndEndDate.forEach((date) => {
    if (date) {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
    }
  });

  const days = [];
  const oneDayInMilliseconds = 864e5;
  for (let i = Number(startAndEndDate[0]); i <= Number(startAndEndDate[1]); i += oneDayInMilliseconds) {
    if (holidays.includes(i)) continue; // Exclude Holidays passed as integers/milliseconds
    let date = new Date(i);
    if (noWeekends && [0, 6].includes(date.getDay())) continue; // Exclude Saturdays and Sundays

    if (isForCalendarEvents) {
      // Because CalendarEvents are all saved at 00:00:00 UTC
      date.getTimezoneOffset() === -120 ? date.setHours(2) : date.setHours(1);
    }

    days.push(date.toUTCString());
  }
  return days;
}

function padDate(n) {
  return n.toString().padStart(2, '0');
}
function isNotZeroDay(day) {
  return day.value > 0;
}
function dayToMilliseconds(day) {
  return Number(day.date);
}

export default {
  getDateFromNowAddWeeks,
  getStartAndEndDate,
  isDateBetweenDates,
  addHoursToDate,
  getUTCDateRange,
  padDate,
  isNotZeroDay,
  dayToMilliseconds,
};
